import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import DefaultLayout from 'components/DefaultLayout';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { TextEditor } from 'ui';
import useQueryApiClient from 'utils/useApiClient';
import { Button } from 'ui';
import generalHelpers from 'utils/generalHelpers';
import { Col, Form, message, Row } from 'antd';

interface DescriptionInterface {
    program: any;
    session: any;
    launchButton: HTMLElement;
}

const mapStateToProps = (state: any) => {
    return {
        session: state.session,
    };
};

const Description: React.FC<DescriptionInterface> = ({ program, session, launchButton }) => {
    const [htmlOutput, setHtmlOutput] = useState('');

    const params = useParams();

    const programId = params.id;
    const [form] = Form.useForm();
    const intl = useIntl();

    useEffect(() => {
        if (program) {
            if (generalHelpers.isPlatformAdmin(session.active_user_type)) {
                form.setFieldsValue({
                    ownerType: program.ownerType,
                    ownerUuid: program.ownerUuid,
                });
            }
        }
    }, [program]);

    const { appendData: submitForm, isLoading } = useQueryApiClient({
        request: {
            disableOnMount: true,
            url: `/api/v1/courses/learning-program/${programId}/update`,
            method: 'PUT',
        },
        onSuccess() {
            message.success(intl.formatMessage({ id: 'general.success' }));
        },
    });

    return (
        <>
            <div className="campaign-header-text">
                <h1 className="text-18">
                    {intl.formatMessage({ id: 'program.student_description_header' })}
                </h1>
            </div>
            <Row>
                <Col offset={3} span={18}>
                    <TextEditor
                        disabled={!(!!programId && !!program?.visualPermissions?.edit)}
                        initial={
                            program && program?.studentDescription ? program.studentDescription : ''
                        }
                        setHtmlOutput={setHtmlOutput}
                    />
                </Col>
            </Row>
            <DefaultLayout.PageFooter
                right={
                    <>
                        <Button
                            disabled={!!(programId && !program?.visualPermissions?.admin)}
                            loading={isLoading}
                            type="primary"
                            onClick={() => submitForm({ studentDescription: htmlOutput })}
                            message={'general.save'}
                        />
                        {launchButton}
                    </>
                }
            />
        </>
    );
};

export default connect(mapStateToProps)(Description);
